import { render, staticRenderFns } from "./SysVoiceVideo.vue?vue&type=template&id=0ea601d8&"
import script from "./SysVoiceVideo.vue?vue&type=script&lang=js&"
export * from "./SysVoiceVideo.vue?vue&type=script&lang=js&"
import style0 from "./SysVoiceVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports